// extracted by mini-css-extract-plugin
export var activeDot = "_2b-c";
export var buttonContainer = "_2b-9";
export var channelButton = "_2b-a";
export var clickable = "_2b-d";
export var content = "_2b-0";
export var contentFull = "_2b-2";
export var contentThird = "_2b-1";
export var contentWrapper = "_2b-7";
export var description = "_2b-5";
export var heightShort = "_2b-f";
export var image = "_2b-3";
export var imageContainer = "_2b-4";
export var selectButton = "_2b-e";
export var spinnerContainer = "_2b-b";
export var titleContent = "_2b-8";
export var titleWrapper = "_2b-6";